import DonationStateTag from '@/core/components/DonationStateTag/DonationStateTag';

export default DonationStateTag;
